export const dropRates = {
  book: [
    [2.52, 0, 0],
    [2.52, 1.0, 0.0],
    [1.79, 2.0, 0.0],
    [2.197, 1.977, 0.227],
  ],
  weapon: [
    [4.57, 0.0, 0.0, 0.0],
    [2.58, 2.0, 0.0, 0.0],
    [2.26, 2.77, 0.21, 0.0],
    [2.205, 2.404, 0.626, 0.073],
  ],
  boss: [
    [2.09, 0.0, 0.0, 0.0, 1.7],
    [2.12, 0.0, 0.0, 0.0, 1.72],
    [1.17, 1.26, 0.0, 0.0, 1.57],
    [1.21, 1.35, 0.0, 0.0, 1.95],
    [1.46, 1.42, 0.11, 0.0, 2.03],
    [1.74, 1.44, 0.11, 0.0, 2.23],
    [1.93, 1.55, 0.12, 0.013, 2.37],
    [2.15, 1.61, 0.13, 0.021, 2.55],
    [2.15, 1.53, 0.19, 0.016, 2.55],
  ],
};
